import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Image,
  Navbar,
  NavbarBrand,
  NavbarContent,
} from '@nextui-org/react';
import { CtyButton } from '../button/CtyButton';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import { checkType, CtyShowToast } from '../toast/CtyToast';
import { getPalUrl, injectPalChatbot } from '../utils/commonutils';
import { useScreenWidth } from '../utiluicomponents/useScreenWidth';
import { CartItemsList } from '../utiluicomponents/cartItemsList';
import { RootState, useGetTenantMetadataQuery } from '@circuitry-ai/doc-data';
import { useSelector } from 'react-redux';
import { useTheme } from '../context/ThemeContext';
import { ThemeModeSwitcher } from './ThemeModeSwitcher';
import { useSyncDefaultAdvisorPalMode } from './useSyncDefaultAdvisorPalMode';
export interface CtyHeaderProps {
  logo?: string;
  onOpen?: () => void;
  isCollapsed?: boolean;
  isFileViewer?: boolean;
}

export function CtyHeader(props: Readonly<CtyHeaderProps>) {
  const { onOpen, isCollapsed = false, isFileViewer = false } = props;
  const { isDark } = useTheme();
  const navigate = useNavigate();
  const width = useScreenWidth();
  const token = useSelector((state: RootState) => state.auth.token);
  const isMobile = width < 640;
  const { data: tenantMetadata } = useGetTenantMetadataQuery(undefined, { skip: !token });
  const defaultAdvisorMode = useSyncDefaultAdvisorPalMode();

  const handleLaunchPAL = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const key = e.currentTarget.getAttribute('data-key');
    if (key === 'window_view') {
      const palUrl = getPalUrl();
      if (palUrl) {
        window.open(palUrl, '_blank', 'noopener,noreferrer');
      }
    } else if (key === 'in_app_view') {
      injectPalChatbot(CtyShowToast, checkType, tenantMetadata?.widget_icon_url, {
        open: true,
        resolveTargetMode: () => defaultAdvisorMode,
      });
    }
  };
  
  return (
    <Navbar isBordered maxWidth="full" isBlurred={false} position="sticky" classNames={{ base: 'cty-app-header' }}>
      <div className="sm:hidden">
        <CtyButton
          isIconOnly
          className="flex  "
          size="sm"
          variant="light"
          onPress={onOpen}
        >
          <Icon
            className="text-default-500"
            height={24}
            icon="solar:hamburger-menu-outline"
            width={24}
          />
        </CtyButton>
      </div>
      {(isCollapsed || isMobile) && (
        <div>
          <NavbarBrand>
            <Image
              className="cursor-pointer"
              onClick={() => navigate('/')}
              src={props.logo}
              alt="Logo"
              width={150}
            />
          </NavbarBrand>
        </div>
      )}
      {isFileViewer && (
        <CtyButton className='flex gap-4 items-center h-[40px]' variant='light' disableRipple={true} size="sm" onPress={() => navigate('/')}>
          <Image src={isDark ? '/Logo-dark.svg' : '/Logo.svg'} alt="Logo" width={150} />
        </CtyButton>
      )}

      <NavbarContent as="div" justify="end" id="user-profile-btn" className='flex gap-2 sm:gap-4'>
        <ThemeModeSwitcher />
        <Dropdown>
          <DropdownTrigger>
            <Button
              variant="bordered"
              size="lg"
              className="border-0 relative bg-gradient-to-r from-[#D4007E] to-[#003A79] dark:from-[#D4007E] dark:to-primary p-[2px] text-default-500 font-semibold hidden sm:block"
            >
              <span className="bg-content1 flex items-center text-sm justify-center w-full h-full rounded-medium px-3 text-default-500  font-semibold leading-6 font-poppins">
                Open PAL
              </span>
            </Button>
          </DropdownTrigger>
          <DropdownMenu aria-label="Static Actions">
            <DropdownItem
              key="window_view"
              onClick={handleLaunchPAL}
              className="launch-pal"
            >
              New PAL Window <Icon icon="radix-icons:open-in-new-window" />
            </DropdownItem>
            <DropdownItem
              key="in_app_view"
              onClick={handleLaunchPAL}
              className="launch-pal"
            >
              Widget <Icon icon="solar:chat-line-linear" />
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <CartItemsList />
      </NavbarContent>
    </Navbar>
  );
}

export default CtyHeader;
